<template>
  <div>
    <Panel class="configurations" :title="$t('parameters')">
      <div class="columns">
        <div class="column">
          <div class="group">
            <label>{{$t('report_type')}}</label>
            <select v-model="report">
              <option value="transactions">{{$t('transactions')}}</option>
              <option value="balances">{{$t('loyalty.gift_card_report')}}</option>
            </select>
          </div>
          <div class="group" v-if="isBalanceReport">
            <label>{{$t('date')}}</label>
            <datetime
              type="datetime"
              v-model="parameters.atTime"
              :use12-hour="hourFormat === '12'"
              value-zone="local"
              input-style="width: 100%"
              :max-datetime="now"
            />
          </div>
          <div class="group" v-if="isTransactionReport">
            <label>{{$t('start')}}</label>
            <datetime
              type="date"
              :use12-hour="hourFormat === '12'"
              v-model="parameters.start"
              value-zone="local"
              input-style="width: 100%"
              :max-datetime="parameters.end"
            />
          </div>
          <div class="group" v-if="isTransactionReport">
            <label>{{$t('end')}}</label>
            <datetime
              type="date"
              :use12-hour="hourFormat === '12'"
              v-model="parameters.end"
              value-zone="local"
              input-style="width: 100%"
              :min-datetime="parameters.start"
              :max-datetime="now"
            />
          </div>
        </div>

        <div class="column"></div>
      </div>

      <button class="btn btn-primary" @click="generate">{{$t('generate')}}</button>
    </Panel>

    <Panel>
      <RawTable v-if="tableData" :columns="tableData.columns" :rows="tableData.rows" :keyValueHeader="queryOptions"/>
      <div v-else>{{$t('when_no_report')}}</div>
    </Panel>
  </div>
</template>

<script>
import RawTable from "@/components/RawTable";
import { mapActions } from "vuex";
import moment from "moment-timezone";
import { DateTime } from "luxon";

export default {
  name: "GiftCardReports",
  components: { RawTable },

  data() {
    return {
      now: DateTime.local().toISO(),
      report: 'transactions',
      parameters: {
        start: moment().toISOString(),
        end: moment().toISOString(),
        atTime: moment().set({hour:0,minute:0,second:0,millisecond:0}).toISOString(),
      },
      queryOptions: null,
      tableData: null
    }
  },

  computed: {
    branchId() {
      return this.$route.query.branch;
    },
    companyId() {
      return this.$route.query.company;
    },
    hourFormat() {
      if (this.$store.state.contextCompany) {
        return this.$store.state.contextCompany.hourFormat;
      }
      return "24";
    },
    isTransactionReport() {
      return this.report === 'transactions'
    },
    isBalanceReport() {
      return this.report === 'balances'
    },
  },

  mounted() {
    this.$store.state.pageTitleTranslationKey = "gift_card.reports_title";
    this.$store.state.pageIcon = "/icon/loyalty.svg";
  },

  methods: {
    ...mapActions(["reportGiftCardBalances", "reportGiftCardTransactions"]),

    async generate() {
      let response = null;
      if (this.isTransactionReport) {
        response = await this.report_transactions();
      } else if (this.isBalanceReport) {
        response = await this.report_balances();
      }
      if (response) {
        this.tableData = response.data;
        this.queryOptions = response.query;
      } else {
        toast(this.$t('error.no_server'), 'error');
      }
    },

    async report_transactions() {
      return await this.reportGiftCardTransactions({
        options: {
          branch: this.branchId,
          company: this.company || undefined,
          start: this.parameters.start,
          end: this.parameters.end.replace('00:00:00', '23:59:59'),
        }
      });
    },

    async report_balances() {
      return await this.reportGiftCardBalances({
        options: {
          branch: this.branchId,
          atTime: this.parameters.atTime
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>

</style>